import React from "react";
import { useGeneralContext } from "../../context/GeneralContext";
import useWindowWidthCalculate from "../../hooks/useWindowWidthCalculate";
import CountdownBar from "../CountdownBar";

import * as S from "./styles";

const PromotionalBanner = () => {
  const { windowWidth } = useWindowWidthCalculate();
  const {
    isPromoPeriod,
    showCountdown,
    hasPromotionalBannerImages,
    promotionalBanner,
  } = useGeneralContext();

  if (!hasPromotionalBannerImages || !isPromoPeriod) return <></>;

  return (
    <>
      {showCountdown && <CountdownBar text="Corre que tá acabando" />}
      <a href={promotionalBanner.linkBanner}>
        <S.Wrapper>
          <img
            src={
              windowWidth >= 1024
                ? promotionalBanner.largeBanner.url
                : promotionalBanner.smallBanner.url
            }
            alt={promotionalBanner.largeBanner.alternativeText}
          />
        </S.Wrapper>
      </a>
    </>
  );
};

export default PromotionalBanner;
